import React, { useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap/esm/index";
import Helmet from "react-helmet";
import { helmetJsonLdProp } from "react-schemaorg";
import { Link } from "react-router-dom";

// Import Components
import HalfTextHalfImageHero from "../../components/HeroHeader/HalfTextHalfImageHero";
import ITPHeroHeader from "../../components/HeroHeader/ITPHeroHeader";
import Accordion from "../../components/shared-ui/Accordion/Accordion";
import ItpNavigation from "../../components/ITPNavigation/ITPNavigation";
import FooterITP from "../../components/shared-ui/Footer/Footer-ITP";
import BackToTopBtn from "../../components/shared-ui/BackToTopBtn/BackToTopBtn";
import ISIITPinline from "../../components/shared-ui/ISI/ISIITP-inline";
import ISIwrapper from "../../components/shared-ui/ISI/ISI-wrapper";
import ISIITP from "../../components/shared-ui/ISI/ISIITP";
import YoutubeEmbed from "../../components/shared-ui/Video/YoutubeEmbed";
import PrimaryButton from "../../components/shared-ui/Buttons/PrimaryButton";

function SupportAndResources() {
  useEffect(() => {
    window.scrollTo(0, 0);
    let location = window.location.pathname;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      page: {
        path: `${location}`,
        title: "ITP Support & Resources | DOPTELET® (avatrombopag)",
        environment: "dev",
        indication: "ITP",
        audience: "DTC",
      },
    });
  }, []);

  return (
    <div className="main_content_wrap">
      <Helmet>
        <title>
          Chronic ITP Patient Support & Resources | DOPTELET® (avatrombopag)
        </title>
        <meta
          name="description"
          content="Access Doptelet's support and resources for chronic ITP, like tips for managing ITP, patient brochures, financial assistance options & more."
        />
        <link
          rel="canonical"
          href="https://doptelet.com/support-and-resources/"
        />
      </Helmet>
      <ItpNavigation />
      <div className="inner-content-wrap">
        <ITPHeroHeader
          extraClass="large-hero inner-bg"
          markup={
            <>
              <h1>CHRONIC ITP RESOURCES</h1>
              <p className="mb-0">
                If you’re interested in learning how to access treatment with Doptelet, find helpful resources, get financial assistance, discover ITP tips, or read FAQs, you’ve come to the right place.
              </p>
            </>
          }
          maxWidth="513"
          bgImage={["support-resources-hero.jpg", "support-resources-hero.jpg"]}
          bgImageMobile={[
            "support-resources-hero-mobile.jpg",
            "support-resources-hero-mobile.jpg",
          ]}
          imageAlt="Doptelet platelet character with son at carnival game"
        />

        <section className="section-padding resource-cards">
          <Container>
            <Row>
              <Col>
                <h2 className="mb-4">What kind of support do you need?</h2>
              </Col>
            </Row>
            <Row>
              <Col md={12} lg={6} className="mb-4 mb-lg-0">
                <div className="cloud-blue-bg">
                  <div className="d-flex align-items-center mb-3">
                    <img
                      style={{maxWidth: 64}}
                      src="/images/resources-icon.png"
                      alt="Doptelet Patient Information and Resources Magnifying Glass Icon"
                      className="mr-3"
                    />
                    <h4 className="mb-0"><strong>Patient Resources</strong></h4>
                  </div>
                  <p>View the ITP patient resources for helpful downloads, information about support organizations, and more.</p>
                  <Link
                    to="/support-and-resources/itp-patient-resources/"
                    className="btn btn-primary btn-arrow w-100">
                    <span>LEARN MORE</span>
                  </Link>
                </div>
              </Col>
              <Col md={12} lg={6}>
                <div className="cloud-blue-bg">
                  <div className="d-flex align-items-center mb-3">
                    <img
                      style={{maxWidth: 64}}
                      src="/images/financial-assistance-icon.png"
                      alt="Search bar with mouse icon representing Doptelet financial assistance programs"
                      className="mr-3"
                    />
                    <h4 className="mb-0"><strong>Financial Assistance</strong></h4>
                  </div>
                  <p>Discover programs that might help you save on treatment, such as the Copay Assistance Program or Free Trial Offer.</p>
                  <Link
                    to="/support-and-resources/financial-assistance/"
                    className="btn btn-primary btn-arrow w-100">
                    <span>LEARN MORE</span>
                  </Link>
                </div>
              </Col>
            </Row>
            <Row>
              <Col md={12} lg={6} className="mb-4 mb-lg-0 h-100">
                <div className="cloud-blue-bg">
                  <div className="d-flex align-items-center mb-3">
                    <img
                      style={{maxWidth: 64}}
                      src="/images/icon-prescription.svg"
                      alt="Icon representing doctor discussion guide and chronic itp tips documents for patients"
                      className="mr-3"
                    />
                    <h4 className="mb-0"><strong>Get ITP Tips</strong></h4>
                  </div>
                  <p>Sign up to receive tools and tips, including a free journal to help you track your platelet counts, symptoms, and treatment—plus you’ll get some surprises, too!</p>
                  <Link
                    to="/support-and-resources/living-with-itp/"
                    className="btn btn-primary btn-arrow w-100">
                    <span>LEARN MORE</span>
                  </Link>
                </div>
              </Col>
              <Col md={12} lg={6}>
                <div className="cloud-blue-bg h-100 d-flex flex-column">
                  <div className="d-flex align-items-center mb-3">
                    <img
                      style={{maxWidth: 64}}
                      src="/images/tips-icon.png"
                      alt="Icon representing doctor discussion guide and chronic itp tips documents for patients"
                      className="mr-3"
                    />
                    <h4 className="mb-0"><strong>FAQs</strong></h4>
                  </div>
                  <p className="flex-grow-1">Get answers to the most commonly asked questions about ITP and Doptelet.</p>
                  <Link
                    to="/chronic-itp-faqs/"
                    className="btn btn-primary btn-arrow w-100">
                    <span>LEARN MORE</span>
                  </Link>
                </div>
              </Col>
            </Row>
          </Container>
        </section>

        <ISIITPinline />
      </div>
      <FooterITP />
      <ISIwrapper>
        <ISIITP />
      </ISIwrapper>
      <BackToTopBtn />
    </div>
  );
}

export default SupportAndResources;
